<div
  class="flex flex-row space-x-2 items-center text-lg rounded p-2 w-full text-black dark:text-white bg-white dark:bg-gray-950">
  <div class="relative flex-none rounded-full p-1 custom-border dark:border-gray-750">
    <app-profile-picture [fitMedProfileId]="fitMedProfile?.id" [src]="customProfilePicture ?? null"
    class="w-10 h-10 flex-none"></app-profile-picture>
  </div>

  <div class="flex flex-col overflow-hidden">
    <!-- Title -->
    @if (navigationEnabled) {
      <a class="title hover:underline title-font-selector" [routerLink]="nameLink"
        [queryParams]="{ practitionerId, patientFitMedProfileId }">
        {{ title ?? fullName }}
      </a>
    }

    @if (!navigationEnabled) {
      <span class="title">{{ title ?? fullName }}</span>
    }

    <div class="subtitle text-black dark:text-white">
      <!-- gender && dob if no sub title -->
      @if (!subtitle) {
        <app-gender [fitMedProfile]="fitMedProfile" [name]="true" [icon]="false"></app-gender>
        <span class="m-1">|</span>
        <span>{{ getAgeFromDOB(fitMedProfile?.doB) }}</span>
      }
    </div>
  </div>
</div>
